<div *ngIf="comment" class="comment">
  <div class="comment__header">
    <avatar [imageUrl]="imageUrl(comment.employee?.userPerson?.photo)" [width]="24"></avatar>
    <span class="name"><span class="pii">{{ comment.employee?.userPerson?.notificationName }}</span></span>
    <span class="date">{{ comment.created | dateTimeFormat }}</span>
  </div>
  <div class="comment__subheader">
    {{ comment.startDate | date: 'dd.MM.yyyy' }} - {{ comment.endDate | date: 'dd.MM.yyyy' }}
  </div>
  <div class="comment__content">
    {{ comment.employee ? comment.note : ('Projects.Period.initialDateRangeComment' | translate) }}
  </div>
</div>
